import axios from 'axios';

const API_BASE_URL = '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const procedureAPI = {
  getProcedureTypes: () => api.get('/api/procedure-types'),
  
  createSchedule: (data) => api.post('/api/schedule', data),
  getSchedule: (date) => api.get(`/api/schedule/${date}`),
  deleteSchedule: (date) => api.delete(`/api/schedule/${date}`),
  
  getStats: (date) => api.get(`/api/schedule/${date}/stats`),
  
  updateAppointmentStatus: (id, status) => 
    api.patch(`/api/appointments/${id}/status?status=${status}`),
  
  // FIX: Add encodeURIComponent for patient name with spaces
  updatePatientStatus: (name, date, status) =>
  api.patch(`/api/patients/${encodeURIComponent(name)}/status?date=${date}&status=${status}`),

  deletePatientAppointments: (name, date) =>
    api.delete(`/api/patients/${encodeURIComponent(name)}/appointments?date=${date}`),
};

export default api;
